import { useAuth } from "@/auth/AuthContext";
import { ForgotPasswordModal } from "@/components/ForgotPasswordModal";
import { Button, Stack, Text, TextInput, Title, useMantineTheme } from "@mantine/core";
import { isEmail, useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function EmailLoginPage() {
  const theme = useMantineTheme();
  const { signInWithEmail } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPasswordModalOpened, setForgotPasswordModalOpened] = useState(false);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: isEmail("이메일 형식이 올바르지 않습니다"),
      password: (value) => (value.length > 0 ? null : "비밀번호를 입력해주세요"),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setIsLoading(true);
    try {
      await signInWithEmail(values);
      navigate("/home", { replace: true });
    } catch (error: any) {
      const isInvalidCredentials = error?.message === "Invalid login credentials";
      notifications.show({
        title: "로그인 실패",
        message: isInvalidCredentials
          ? "이메일 또는 비밀번호가 올바르지 않습니다."
          : "로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack h="100%" pb="lg" px="xl">
      <form onSubmit={form.onSubmit(handleSubmit)} style={{ height: "100%" }}>
        <Stack justify="space-between" h="100%">
          <div></div>
          <Stack>
            <Title ta="center" order={1} size="3.5rem" lh="1.5">
              이메일 로그인
            </Title>
            <TextInput
              label="Email"
              placeholder="your@email.com"
              {...form.getInputProps("email")}
              w="100%"
              size="lg"
            />
            <TextInput
              label="Password"
              placeholder="Your password"
              type="password"
              {...form.getInputProps("password")}
              w="100%"
              size="lg"
            />
            <Text
              size="sm"
              c="blue"
              style={{ cursor: "pointer", textAlign: "right" }}
              onClick={() => setForgotPasswordModalOpened(true)}
            >
              비밀번호를 잊으셨나요?
            </Text>
          </Stack>
          <Button
            type="submit"
            size="lg"
            fullWidth
            color={theme.colors.yellow[0]}
            style={{ color: "black" }}
            radius="xl"
            loading={isLoading}
            mb="lg"
          >
            로그인
          </Button>
        </Stack>
      </form>
      <ForgotPasswordModal
        opened={forgotPasswordModalOpened}
        onClose={() => setForgotPasswordModalOpened(false)}
      />
    </Stack>
  );
}
